import type { ReactNode } from "react";
import DashboardIcon from "@mui/icons-material/Dashboard";
import EventNoteIcon from "@mui/icons-material/EventNote";
import LocalPharmacyIcon from "@mui/icons-material/LocalPharmacy";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import MeetingRoomIcon from "@mui/icons-material/MeetingRoom";
import PeopleIcon from "@mui/icons-material/People";
import { AppShell as SharedShell, type NavItem } from "@workspace/admin-ui";

export { PageHeader } from "@workspace/admin-ui";

const nav: NavItem[] = [
  { to: "/", label: "Dashboard", icon: DashboardIcon },
  { to: "/pharmacies", label: "Pharmacies", icon: LocalPharmacyIcon },
  { to: "/pharmacists", label: "Pharmacists", icon: PeopleIcon },
  { to: "/bookings", label: "Bookings", icon: EventAvailableIcon },
  { to: "/rooms", label: "Rooms & Availability", icon: MeetingRoomIcon },
  { to: "/consultations", label: "Consultations", icon: EventNoteIcon },
];

const titleSuffix = import.meta.env.VITE_APP_TITLE_SUFFIX ?? "";

export function AppShell({ children }: { children: ReactNode }) {
  return (
    <SharedShell title={`Chain Admin${titleSuffix}`} nav={nav}>
      {children}
    </SharedShell>
  );
}
